import React from "react";

const IconShare = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        d="M4 21H2v-3.111C2 12.425 6.48 8 12 8V2.799L22.519 12 12 21.202V16c-3.682 0-8 2.776-8 5zm8-7h2v2.795L19.481 12 14 7.206V10h-2c-4.16 0-7.575 3.13-7.963 7.127C6.019 15.3 9.14 14 12 14z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default IconShare;
